<template>
        <div class="uk-width-5-6 overview">
            <div class="uk-card uk-card-default uk-card-body uk-text-large border-radius">
                <h3 class="uk-card-title uk-text-bolder">Kies een opdracht of druk op het logo om de lijst te verversen</h3>
            </div>
            <div
                :class="getAssignmentClasses(assignment)"
                v-for="assignment in assignments"
                :key="assignment.id"
                @click="selectAssignment(assignment)"
            >
                <h3 class="uk-card-title uk-text-bolder">{{ assignmentStartTimeString(assignment) }}</h3>
                {{ assignment.orderId }} <br />
                {{ assignment.description }} <br />
                {{ assignment.customer }}
            </div>
        </div>
</template>

<style scoped>
    .overview {
        margin: 0 auto;
        text-align: center;
    }

    .border-radius {
        border-radius: 25px;
    }

    .disabled-assignment {
        background-color: #d8d7d7;
    }

    .enabled-assignment {
        cursor:        pointer;
    }
</style>

<script>
import moment from 'moment';

export default {
    name: "ProjectList",

    props: {
        assignments: {
            type: Array,
            default: () => [],
        },

        constants: { type: Object, required: true },
    },

    methods: {
        selectAssignment(assignment) {
            if (! this.mayStartAssignment(assignment)) {
                return;
            }

            this.$emit('select-assignment', assignment);
        },

        assignmentStartTimeString(assignment) {
            let startMoment = moment.parseZone(assignment.startsAt, moment.ISO_8601);

            return startMoment.format('DD-MM-YYYY HH:mm');
        },

        mayStartAssignment(assignment) {
            let startMoment   = moment.parseZone(assignment.startsAt, moment.ISO_8601);
            let currentMoment = moment();

            return (currentMoment.isSameOrAfter(startMoment.subtract(4, 'h')));
        },

        getAssignmentClasses(assignment) {
            return 'uk-card uk-card-default uk-card-body uk-margin-large-top uk-margin-large-bottom uk-text-large uk-text-left border-radius'
                + (this.mayStartAssignment(assignment) ? ' enabled-assignment' : ' disabled-assignment')
            ;
        },
    }
};
</script>
